import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Container = styled.div`
  position: relative;
`;

export const ProductsText = styled.button`
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 14px;
  /* identical to box height */
  align-items: center;
  text-align: right;
  justify-content: flex-start;
  cursor: pointer;
  border: none;
  background: transparent;

  /* beam-colors/beam-accent */
  color: #1371fe;
`;
export const Block = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  top: 0;
  right: 0;
  width: 637px;
  max-height: 333px;
  z-index: 10;
`;
export const Icon = styled(FontAwesomeIcon)`
  width: 11px;
  height: 14px;
  margin-left: 8px;
`;
